import { Box } from "@mui/material"

const List = () => {

  return <Box sx={{ height: '80vh', display: "flex", alignItems: 'center', justifyContent: 'center' }}>
    <img src="/assets/images/restriction-img.png" alt="" style={{ height: '50%', width: '30%', minWidth: '400px', minHeight: '400px', display: 'block', margin: '0 auto' }} />
  </Box>
}

export default List
